import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";
import LifetimeValueByMembershipModule from "./byMembershipType/index";
import MembershipLengthByAgreementModule from "./membershipLengthByAgreement/index";

const pageConfig = {
  pageName: "Lifetime Value and Length",
  configuratorWidth: 420,
  moduleList: [LifetimeValueByMembershipModule, MembershipLengthByAgreementModule]
};

const LifetimeValueAndLengthPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default LifetimeValueAndLengthPage;
